<div class="dialog-main">
  <div class="header mt-3 mb-5">
    <h2 class="modal-title text-center heading2">
      <b>
        {{ title }}
      </b>
      <button type="button" class="close" (click)="rejectDialog()">
        <span> <img src="/assets/svg/ico-cross.svg" /> </span>
      </button>
    </h2>
  </div>
  <div
    class="rounded-top body-container d-flex justify-content-center align-items-center"
  >
    <div class="body-text mx-2">
      <h1>
        <b>{{ headingText }}</b>
      </h1>
      <br />
      <p class="text">
        {{ bodyText }}
      </p>
      <br />
      <p class="text">
        {{ footerText }}
      </p>
    </div>
  </div>

  <div class="row my-2">
    <div class="col-12 my-1">
      <button
        class="btn btn-danger px-3 w-100 done-btn"
        type="button"
        (click)="acceptDialog()"
      >
        {{ 'YES' | translate }}
      </button>
    </div>
  </div>

  <div class="row my-2">
    <div class="col-12 my-1">
      <button
        type="button"
        (click)="rejectDialog()"
        class="add-button px-5 py-3 mt1 mb-4 w-100"
      >
        <strong> {{ 'NO' | translate }} </strong>
      </button>
    </div>
  </div>
</div>
